import moment from 'moment';
import { Injectable } from '@angular/core';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { ConvertNumToNameFactory } from '@shared/factories/convert-num-to-name/convert-num-to-name.factory';
import { CurrentPageService } from '@shared/factories/current-page/current-page.service';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { UserPermisionsFactory } from '@shared/factories/user-permisions/user-permisions.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { BroadcastService } from '@shared/services/broadcast/broadcast.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { DateConverterService } from '@shared/services/date-converter/date-converter.service';
import { DownloadService } from '@shared/services/download/download.service';
import { ExpandedMenuService } from '@shared/services/expanded-menu/expanded-menu.service';
import { ExportServiceService } from '@shared/services/export-service/export-service.service';
import { FilterColumnService } from '@shared/services/filter-column/filter-column.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { RegisterMixtapeService } from '@shared/services/register-mixpanel/register-mixtape.service';
import { cloneDeep} from 'lodash';
import ExpandMenu from '../../../../../assets/data/expanded-menu.json';
import { EditDocumentOffice365Factory } from '@shared/factories/edit-document-office-365/edit-document-office-365.factory';
import { AnonymizedProcessService } from '@shared/services/anonymized-process/anonymized-process.service';
import { GenialDocumentsService } from '@shared/services/genial-documents/genial-documents.service';

@Injectable({
  providedIn: 'root'
})
export class ConceptListParentService {
  subscribers: any = {};
  expandedMenu: any = ExpandMenu;
  constructor(
    private translate: AfTranslateFactory,
    private userPermisions: UserPermisionsFactory,
    private commonUtilsService: CommonUtilsService,
    private context: ContextFactory,
    private broadcastService: BroadcastService,
    private currentPage: CurrentPageService,
    private registerService: RegisterMixtapeService,
    private convertNumbToName: ConvertNumToNameFactory,
    private dateConverterService: DateConverterService,
    private loader: LoaderFactory,
    private apiService: ApiServiceService,
    private modalService: ModalServiceService,
    private filterColumnService:FilterColumnService,
    private exportService: ExportServiceService,
    private downloadService: DownloadService,
    private expandedMenuService: ExpandedMenuService,
    private editDocumentOffice365: EditDocumentOffice365Factory,
    private anonymizedProcessService: AnonymizedProcessService,
    private genialDocumentsService: GenialDocumentsService
  ) { }

  OnChanges(child:any, changes: any) {
    let that: any = child.conceptList;
    if ((changes['toShow']?.currentValue || changes['modify']?.currentValue) && child.conceptInfo.conceptId) {
      if(child.toShow !== 'archived' && child.conceptInfo.namedKey === 'Consulta'){
        child.conceptList.configuratedListICAM = false;
      }
      this.ConfigureEvaluatedConcepts(child);
    }
    if (child.modify) {
      child.launchAction.emit({type: 'updateConcept'});
    }
    if (!child.conceptInfo.conceptId) {
      that.typeObjectId = 'reportObjectId';
      this.ConfigureReports(child);
    }
    that.showAnonymatum = child.conceptInfo.communicationChannel;
    that.contextAnonymatumService = this.context.anonymatumService
  }

  OnInit(child: any) {
    child.userPermissions = this.userPermisions.getPermissions();
    this.subscribers.reloadConceptListBroadcast = this.broadcastService.subscribe('reloadConceptList', (data: any) => {
      if (data.concept.conceptId === child.conceptInfo.conceptId) {
        child.conceptList.configuratedListICAM = false;
        this.loader.openLoader('concept-list-charged');
        this.GetConceptsEvaluated(child);
      }
    });

    this.subscribers.changeReportListBroadcast = this.broadcastService.subscribe('changeReportList', (data:any)=> {
      if(child.conceptInfo.reportId === data.report.reportId){
        child.conceptInfo.reportObjects.push(data.report.newReport);
        this.ConfigureReportList(child);
        this.FilterComponentList(child);
      }
    });

    this.subscribers.changeGlobalReportListBroadcast = this.broadcastService.subscribe('changeGlobalReportList', (data:any)=> {
      if(child.conceptInfo.reportId === data.report.reportId){
        this.ConfigureReportList(child);
        this.FilterComponentList(child);
      }
    });

    // Clear all filters
    this.subscribers.cleanFiltersActiontBroadcast = this.broadcastService.subscribe('cleanFiltersAction', (data:any)=> {
      let that = child.conceptList;
      // Search filters
      that.textFilters.forEach((textFilter: any) => {
        that[textFilter + 'SearchFilter'] = '';
        that[textFilter + 'Filter'].value = '';
      });
      // List filters
      that.filters.forEach((listFilter: any) => {
        that[listFilter + 'ListFilter'] = [];
        that[listFilter + 'List'].forEach((listFilterOption: any) => {
          if ('selected' in listFilterOption) {
            delete listFilterOption.selected;
          }
        });
        that[listFilter + 'Filter'].listValues = [];
        that[listFilter + 'Filter'].hasFilter = false;
      });
      // Creation Date
      if (that.creationDateFilter) {
        that.creationDateFilter = false;
        that.creationDateFromDate = null;
        that.creationDateToDate = null;
      }
      // Modification Date
      if (that.creationDateFilter) {
        that.creationDateFilter = false;
        that.creationDateFromDate = null;
        that.creationDateToDate = null;
      }
      this.FilterComponentList(child);
      // Pagination
      this.changeCurrentPage({currentPage: 1, firstElement: 0}, child);
      that.updateCurrentPage = true;
    });

    this.subscribers.exportInstancesListBroadcast = this.broadcastService.subscribe('exportInstancesList'+child.conceptInfo.conceptId, (data:any)=> {
      this.modalService.exportFormatModal({}).subscribe((result:any) => {
        switch (result.selectedFormat) {
          case 'xls':
            this.ExportToExcel(child);
            break;
          case 'pdf':
            this.ExportToPdf(child);
            break;
        }
      });
    });
    this.ConfigureConceptList(child);
  }

  ConfigureConceptList(child:any){
    let that:any = child.conceptList;
    if((child.toShow && child.conceptInfo) || that.modify){
      this.ConfigureState(child);
      if(child.conceptInfo.list){
        this.GetFilters(child.conceptInfo.list, child);
      }
    }
    that.descriptionEdit = child.userPermissions ==='none' || child.conceptInfo.poll? this.translate.instant('concept-list.description-view') : this.translate.instant('concept-list.description-edit');
    that.deleteConcept = this.translate.instant('concept-list.description-delete');
    that.description = this.translate.instant('concept-list.description-open');
    if(child.conceptInfo.reportId){
      that.deleteConcept = this.translate.instant('concept-list.delete-report');
      that.descriptionEdit = this.translate.instant('concept-list.edit-report');
      that.description = this.translate.instant('report-table.icon-tooltip');
    }
  }

  RememberFilters(child:any){
    let that:any = child.conceptList;
    let type = child.conceptInfo.conceptId ? 'conceptId' : 'reportId';
    let current = this.currentPage.get('concept');
    if(current && current[type] === child.conceptInfo[type]){
      this.currentPage.reset('concept');
      // List filters
      if (current.listFilters) {
        current.listFilterNames.forEach((listfilterName: any) => {
          if (current.listFilters[listfilterName + 'ListFilter'] && current.listFilters[listfilterName + 'ListFilter'].length) {
            that[listfilterName + 'ListFilter'] = [];
            that[listfilterName + 'List'].forEach((elementFilter: any) => {
              for(let i: number = 0; i < current.listFilters[listfilterName + 'List'].length; i++){
                let elementCurrentFilter: any = current.listFilters[listfilterName + 'List'][i];
                if(elementFilter.name === elementCurrentFilter.name){
                  elementFilter.selected = elementCurrentFilter.selected;
                  break;
                }
              }
              if(elementFilter.selected){
                that[listfilterName + 'ListFilter'].push(elementFilter);
              }
            });
            that[listfilterName + 'Filter'].hasFilter = true;
          }
        })
      }
      // Search filters
      if (current.textFilters) {
        for (const [filterKey, filterValue] of Object.entries(current.textFilters)) {
          if (filterValue !== '') {
            that[filterKey] = filterValue;
            that[filterKey.replace('Search', '')].value = filterValue;
          }
        }
        that.textSelectedFilters = current.textFilters;
      }
      // Pagination
      that.configPagination.currentPage = current.configPagination.currentPage;
      that.configPagination.firstElement = current.configPagination.firstElement;
      that.updateCurrentPage = true;
      // Selected concepts
      if (current.selectedConcepts?.length) {
        that.countConceptSelect = [];
        that.conceptList?.forEach((concept: any) => {
          concept.selectedConcept = current.selectedConcepts.includes(concept.conceptObjectId);
          if (concept.selectedConcept) {
            that.countConceptSelect.push(concept);
          }
        });
        that.anySelect = !!(that.countConceptSelect.length);
        that.selectAll = current.selectAll && that.anySelect;
      }
    }
  }

  ConfigureReports(child:any){
    this.loader.openLoader('concept-list-charged');
    this.ConfigureReportList(child);
    this.FilterComponentList(child);
  }

  ConfigureReportList(child:any){
    let that: any = child.conceptList;
    let list : any = child.conceptInfo.reportObjects;
    if(child.toShow === 'archived'){
      that.emptyList = false;
      list = child.conceptInfo.archived;
      if(that.selectedFilters && !that.selectedFilters.nameVersionList){
        that.nameVersionList = this.filterColumnService.extractList('nameVersion', child.conceptInfo.archived);
        that.nameVersionListFilter = [];
        that.selectedFilters.nameVersionList =  that.nameVersionList;
        that.selectedFilters.nameVersionListFilter = that.nameVersionListFilter
      }
    }else{
      that.emptyList = child.conceptInfo.reportObjects?.length?false:true;
      that.messageEmptyList = child.conceptInfo.isNewVersion && child.conceptInfo.archivedAmount?'concept-list.reports-archived':'reports.no-generated-reports';
    }
    if(child.conceptInfo.reportId === 25){
      list.forEach((result: any) => {
        result.showIaActions = this.genialDocumentsService.checkValidGenial(result);
      })
    }
    that.conceptList = cloneDeep(list);
    that.conceptList.sort(this.orderListDate);
    this.GetFilters(that.conceptList, child);
  }

  orderListDate(a:any, b:any) {
    return a.creationDate > b.creationDate ? 1 : a.creationDate < b.creationDate ? -1 : 0;
  }

  GetFilters(data: any, child: any) {
    let that: any = child.conceptList;
    if (!that.filters) {
      that.filters = this.ConfigureFilters(child);
    }
    that.textFilters.forEach((text: any) => {
      that[text + 'Filter'].value = '';
      that[text+'SearchFilter'] = that.textSelectedFilters !== null? that.textSelectedFilters[text+'SearchFilter'] : ''
    });
    that.filters.forEach((filter:any) => {
      let filterType = filter;
      let list = cloneDeep(data);
      if(filter === 'managers'){
        list = this.getAllManager(data);
        filterType = 'fullName';
      }
      that[filter+'List'] = this.filterColumnService.extractList(filterType, list);
      that[filter+'ListFilter'] = [];
      that[filter + 'Filter'].hasFilter = false;
      if(that.selectedFilters !== null){
        let selectedList:any = that.selectedFilters[filter+'List'];
        let newList : any = that[filter+'List']
        selectedList.forEach((selected:any)=>{
          newList.forEach((item:any) => {
            if(selected.selected && selected.name === item.name){
              item.selected = selected.selected;
            }
          });
        })
        let selectedFilterList = that.selectedFilters[filter+'ListFilter'];
        selectedFilterList.forEach((selected:any) => {
          newList.forEach((item:any) => {
            if(selected.name === item.name){
              that[filter+'ListFilter'].push(selected)
            }
          });
        });
      }

      if (filter === 'esPrioritaria') {
        that.esPrioritariaList.forEach((priority:any) => {
          priority.nameTranslate = priority.name? this.translate.instant('common.yes') : this.translate.instant('common.no');
        });
      }
      if(filter === 'alertState'){
        that.alertStateList.forEach((progress:any) => {
          let text: string = 'finished';
          if(progress.name === '1-last-day'){
              text = 'last-day';
          }else if(progress.name === '2-two-days'){
              text = 'two-days';
          }else if(progress.name === '3-more-time'){
              text = 'more-time';
          }
          progress.nameTranslate = this.translate.instant('concept-instances-list.'+text);
        });
      }
    });
    if (that.creationDateFilter) {
      that.creationDateFilter = null;
      that.creationDateFromDate = null;
      that.creationDateToDate = null;
      that.creationDateResetFilter = true;
    }
    if (that.modificationDateFilter) {
      that.modificationDateFilter = null;
      that.modificationDateFromDate = null;
      that.modificationDateToDate = null;
      that.modificationDateResetFilter = true;
    }
    this.loader.closeLoader(['concept-list-charged']);
  }

  getAllManager(list: any){
    let managers: any = [];
    list.forEach((item:any) => {
      if(item.managers?.length){
        managers = managers.concat(item.managers);
      }
    });
    return managers;
  }

  GetConceptsEvaluated(child:any){
    let path = child.skin === 'icam-red' ? 'icam/conceptobjects/byconceptid' : 'conceptobjects/byconceptid';
    this.apiService.get(path, child.conceptInfo.conceptId+'/archived/false')
      .then((data:any)=>{
        child.conceptInfo.list = data;
        this.ConfigureEvaluatedConcepts(child);
      }, (errorData:any)=>{
        this.loader.closeError();
      });
  }

  FilterComponentList(child:any) {
    let that: any = child.conceptList;
    let filterList:any = that.conceptList;
    that.textFilters.forEach((searchWord:any) => {
      filterList = this.filterColumnService.filterByWord(that[searchWord+'SearchFilter'], filterList, searchWord);
    });

    if(that.creationDateFilter){
      filterList = this.FilterDates('creationDate', filterList, child)
    }
    if(that.modificationDateFilter){
      filterList = this.FilterDates('modificationDate', filterList, child)
    }
    this.GetFiltratedColumns(filterList, child);
    if (child.skin === 'icam-red' && (child.conceptInfo.namedKey === 'Consulta' || child.conceptInfo.namedKey === 'Usuario')) {
      this.broadcastService.broadcast('cleanFiltersProp', {
        hasFilters: this.hasFilters(child),
        id: child.conceptInfo.conceptId ? 'con-' + child.conceptInfo.conceptId : 'rep-' + child.conceptInfo.reportId
      })
    }
    this.SaveFilter(child)
  }

  hasFilters(child: any): boolean {
    const concept = child?.conceptList;
    if (!concept) return false;

    // Comprobamos si hay filtros en las listas
    const listHasFilters = concept.filters?.some(
      (filter: string) => concept[`${filter}ListFilter`]?.length > 0
    );

    // Comprobamos si hay filtros de texto activos
    const textHasFilters = concept.textFilters?.some(
      (text: string) => (concept[`${text}SearchFilter`] ?? '') !== ''
    );

    // Comprobamos si hay filtros de fecha
    const dateHasFilters = !!(concept.creationDateFilter || concept.modificationDateFilter);

    // Retornamos si hay cualquiera de ellos
    return !!(listHasFilters || textHasFilters || dateHasFilters);
  }

  ConfigureState(child:any){
    let that: any = child.conceptList;
    if(child.conceptInfo.poll && !child.conceptInfo.publicShared){
        this.GetState(child.conceptInfo.list, child);
    }else if(child.conceptInfo.poll && child.conceptInfo.publicShared && child.conceptInfo.list?.length){
        that.showResultsReports = true;
    }
  }

  ExportToExcel(child:any) {
    let config = this.getExportConfig('xls', child);
    this.exportService.toXls(config);
  }

  ExportToPdf(child:any) {
      let config = this.getExportConfig('pdf', child);
      config.exportDate = this.dateConverterService.setTimezone(new Date());
      config.orderType = child.conceptList.filterOrder;
      config.orderAsc = child.conceptList.order;
      child.conceptList.configurationPdf = config;
      let that : any = this;
      setTimeout(()=>{
          let htmlPrint : any = $('#pdf-concept-list-instances').html();
          config.htmlPrint = htmlPrint;
          that.exportService.toPdf(config);
      });
  }

  getExportConfig(formatDocument:any, child: any) {
      let that: any = child.conceptList;
      let config: any = {
        idPrint: 'pdf-concept-list-instances',
        nameDocument: child.conceptInfo.title+(formatDocument==='xls'?'.xlsx':'.pdf'),
        title: child.conceptInfo.title,
        list: cloneDeep(that.conceptListFilter),
        uploadFile: false,
        landscape: true,
        successCallback: (response:any, blob:any) => {
          delete that.configurationPdf;
          this.downloadService.triggerDownload(blob, config.nameDocument);
          this.modalService.successModal({ text: this.translate.instant('common.export-excel-ok') });
        }
      };
      config.list.forEach((instance:any) => {
          instance.creationDateIso = this.dateConverterService.convertDate(instance.creationDate);
          if(instance.modificationDate){
              instance.modificationDateIso = this.dateConverterService.convertDate(instance.modificationDate);
          }
          instance.managersNames = '';
          if(instance.managers){
            instance.managers.forEach((manager:any) => {
                instance.managersNames += instance.managersNames?', '+ manager.fullName:manager.fullName;
            });
          }
      });
      if (child.skin != 'icam-red') {
          config.typeColumns = ['title', 'author', 'creationDateIso', 'modificationDateIso'];
          config.columns = {
              title: this.translate.instant('common.title'),
              author: this.translate.instant('common.author'),
              creationDateIso: this.translate.instant('common.creation'),
              modificationDateIso: this.translate.instant('common.modification')
          };
          if(child.conceptInfo.poll && !child.conceptInfo.anonymousAccess){
              config.typeColumns.push('state');
              config.columns.state = this.translate.instant('common.state');
          }else if(!(child.conceptInfo.poll && child.conceptInfo.anonymousAccess)){
              config.typeColumns.push('step');
              config.columns.step = this.translate.instant('common.state');
          }
          if(!child.conceptInfo.poll && child.conceptInfo.allowPublicShare){
              config.typeColumns.splice(2,0,'managersNames');
              config.typeColumns.push('conceptObjectId');
              config.columns.managersNames = this.translate.instant('box-queries.manager');
              config.columns.conceptObjectId = this.translate.instant('common.reference');
          }
      } else {
          switch (child.conceptInfo.namedKey) {
              case 'Consulta':
                  config.typeColumns = ['referencia', 'tipo', 'creationDateIso', 'step', 'managersNames', 'numColegiado', 'nombreColegiado', 'materia', 'modificationDateIso', 'esPrioritaria', 'processingHours'];
                  config.columns = {
                      referencia: this.translate.instant('common.reference'),
                      tipo: this.translate.instant('common.type'),
                      creationDateIso: this.translate.instant('concept-instances-list.entry'),
                      step: this.translate.instant('common.state'),
                      managersNames: this.translate.instant('box-queries.manager'),
                      numColegiado: this.translate.instant('concept-list.user-number'),
                      nombreColegiado: this.translate.instant('common.name-surname'),
                      materia: this.translate.instant('concept-list.matter'),
                      modificationDateIso: this.translate.instant('common.modification'),
                      esPrioritaria: this.translate.instant('concept-list.priority'),
                      processingHours: this.translate.instant('common.alerts')
                  };
                  break;
              case 'Digitalizacion':
                  config.typeColumns = ['titulo', 'autores', 'pages', 'creationDateIso'];
                  config.columns = {
                      titulo: this.translate.instant('common.title'),
                      autores: this.translate.instant('concept-list.authors'),
                      pages: this.translate.instant('concept-list.pages-range'),
                      creationDateIso: this.translate.instant('concept-list.registration-date')
                  };
                  break;
              case 'Publicacion':
                  config.typeColumns = ['tipo', 'titulo', 'isbn', 'urlCatalogo', 'autores', 'year', 'creationDateIso', 'porcentajeDigitalizado'];
                  config.columns = {
                      tipo: this.translate.instant('common.type'),
                      titulo: this.translate.instant('common.title'),
                      isbn: this.translate.instant('concept-list.isbn-signature'),
                      urlCatalogo: this.translate.instant('concept-list.icam-catalog'),
                      autores: this.translate.instant('concept-list.authors'),
                      year: this.translate.instant('concept-list.year-publication'),
                      creationDateIso: this.translate.instant('concept-list.registration-date'),
                      porcentajeDigitalizado: this.translate.instant('concept-list.percentage-digitized')
                  };
                  break;
              case 'Usuario':
                  config.typeColumns = ['apellidos', 'nombre', 'email', 'numero', 'estado', 'perfil', 'situacion', 'creationDateIso'];
                  config.columns = {
                      apellidos: this.translate.instant('common.surname'),
                      nombre: this.translate.instant('common.name'),
                      email: this.translate.instant('common.email'),
                      numero: this.translate.instant('concept-list.user-number'),
                      estado: this.translate.instant('common.state'),
                      perfil: this.translate.instant('concept-list.profile'),
                      situacion: this.translate.instant('concept-list.situation') ,
                      creationDateIso: this.translate.instant('concept-list.registration-date')
                  };
                  break;
              case 'Encuesta':
                  config.typeColumns = ['title', 'referencia', 'numColegiado', 'nombreColegiado', 'creationDateIso', 'modificationDateIso'];
                  config.columns = {
                      title: this.translate.instant('common.title'),
                      referencia: this.translate.instant('common.reference'),
                      numColegiado: this.translate.instant('concept-list.user-number'),
                      nombreColegiado: this.translate.instant('common.name-surname'),
                      creationDateIso: this.translate.instant('common.creation'),
                      modificationDateIso: this.translate.instant('common.modification')
                  };
                  break;
          }
      }

      return config;
  }

  SelectTypeOperation(item:any, type:any, child:any){
    let that: any = child.conceptList;
    if(that.selectAll){
      this.SelectMultipleConcept('all', null, child);
      that.filterSelectAll = true;
    }
    let listFilter:any = that[type+'ListFilter'];
    that[type+'ListFilter'] = this.filterColumnService.configureFilterList(listFilter, item);
    this.FilterComponentList(child);
  }

  SelectMultipleConcept(type: string, evaluatedConcept: any = null, child:any, e:any=undefined){
    if(e){
      e.stopPropagation();
    }
    let that: any = child.conceptList;
    that.countConceptSelect = [];
    if(type === 'all'){
        that.selectAll = !that.selectAll
    }
    that.conceptListFilter.forEach((concept:any) => {
      if(type === 'all'){
        concept.selectedConcept = that.selectAll;
      }else if(evaluatedConcept.conceptObjectId === concept.conceptObjectId){
        concept.selectedConcept = !concept.selectedConcept;
      }
      if(concept.selectedConcept){
        that.countConceptSelect.push(concept)
      }
    });
    that.anySelect = !!(that.countConceptSelect.length)
    this.SaveFilter(child);
  }

  ConfigureFilters(child:any) {
    switch (child.skin) {
      case 'uk-steel-blue':
        return ['author', 'step', 'state', 'associatedEvaluationName'];
      case 'icam-red':
        switch (child.conceptInfo.namedKey) {
          case 'Consulta':
            return ['tipo', 'step', 'managers', 'materia', 'esPrioritaria', 'alertState'];
          case 'Publicacion':
            return ['tipo'];
          case 'Digitalizacion':
            return [];
          case 'Usuario':
            return ['estado', 'perfil', 'situacion'];
          case 'Encuesta':
            return [];
          default:
            return ['author', 'step', 'state', 'associatedEvaluationName'];
        }
      default:
        if(child.conceptInfo.reportId && child.conceptInfo.type === 0){
          return ['author', 'status', 'extension'];
        }
        return ['author', 'step', 'managers', 'state', 'associatedEvaluationName', 'nameVersion'];
    }
  }

  ConfigureEvaluatedConcepts(child:any){
    this.loader.openLoader('concept-list-charged');
    if(child.toShow==='archived'){
      if (child.conceptList.stepFilter) {
        child.conceptList.stepFilter.hasFilter = false;
      }
      if(child.conceptInfo.archivedNoCall){
        this.GetArchivedConcepts(child)
        child.conceptInfo.archivedNoCall = false;
      }else{
        this.ConfigureList(child.conceptInfo.archived, child);
      }
    }else if(child.conceptInfo.list){
      this.ConfigureList(child.conceptInfo.list, child);
    }
  }

  GetArchivedConcepts(child:any){
    let path : any = child.skin === 'icam-red' ? 'icam/conceptobjects/byconceptid' : 'conceptobjects/byconceptid';
    this.apiService.get(path, child.conceptInfo.conceptId+'/archived/true')
      .then((data:any)=>{
        child.conceptInfo.archived = data;
        child.conceptInfo.archivedAmount = data.length;
        this.ConfigureList(child.conceptInfo.archived, child);
      }, (errorData:any)=>{})
  }

  ConfigureList(list:any, child:any){
    let that: any = child.conceptList;
    that.conceptList = list;
    that.emptyList = list?.length?false:true;
    that.messageEmptyList = this.configureMessageEmpty(child);
    that.showFilterAssociatedEvaluation = false;
    that.conceptList.forEach((instance:any) => {
      if(instance.associatedEvaluationName){
        that.showFilterAssociatedEvaluation = true;
      }
      if(instance.confidential){
        this.SetConfidential(instance, child);
      }
      if(child.skin === 'icam-red'){
        this.ConfigureEvaluatedConceptICAM(instance, child);
      }
    });
    if(child.conceptInfo && child.conceptInfo.poll){
      this.ConfigureState(child);
      this.GetFilters(child.conceptInfo.list, child);
    }else{
      this.GetFilters(that.conceptList, child);
      if(child.toShow !== 'archived' && !child.conceptList.configuratedListICAM){
        child.conceptList.configuratedListICAM = true;
        this.ConfigureListICAM(child);
      }
    }
    this.RememberFilters(child);
    this.FilterComponentList(child);
  }

  configureMessageEmpty(child: any){
    if(child.conceptInfo.poll){
      return 'folder.no-completed-poll';
    }else if(child.conceptInfo.showArchived){
      return 'folder.no-archived-concepts';
    }else {
      return 'folder.no-evaluated-concepts';
    }
  }

  ConfigureListICAM(child:any){
    if(child.conceptInfo.namedKey === 'Consulta' && child.conceptList.selectedFilters === null && child.conceptList.stepList){
      child.conceptList.stepList.forEach((step:any) => {
        if(!step.selected && (step.name === this.translate.instant('dashboard-reports.enProceso') || step.name === this.translate.instant('dashboard-reports.registrada'))){
          step.selected = true;
          child.conceptList.stepFilter.hasFilter = true;
          child.conceptList.stepListFilter = this.filterColumnService.configureFilterList(child.conceptList.stepListFilter, step);
        }
      });
    }
  }

  SetConfidential(instance:any, child:any){
    this.apiService.get('conceptobjects/confidentialaccess', instance.conceptObjectId)
      .then((data:any)=>{
        instance.confidentialList = data;
      },(errorData:any)=>{})
  }

  ConfigureEvaluatedConceptICAM(instance:any, child:any){
    switch (child.conceptInfo.namedKey) {
      case 'Consulta':
        instance.namedKey = child.conceptInfo.namedKey;
        this.commonUtilsService.configureAlertState(instance);
        break;
      case 'Publicacion':
        instance.year = instance.anioPublicacionFin?instance.anioPublicacion+'-'+instance.anioPublicacionFin:instance.anioPublicacion;
        break;
      case 'Digitalizacion':
        instance.pages = '';
        if(instance.paginaInicio && instance.paginaFin){
          instance.pages = instance.paginaInicio+'-'+instance.paginaFin;
        }else if(!instance.paginaInicio && instance.paginaFin){
          instance.pages = '-'+instance.paginaFin;
        }else if(instance.paginaInicio && !instance.paginaFin){
          instance.pages = instance.paginaInicio+'-';
        }
        break;
      case 'Usuario':
        break;
      default:
        break;
    }
  }

  GetState(list:any, child:any){
    let that: any = child.conceptList
    child.conceptInfo.answered = 0;
    child.conceptInfo.pending = 0;
    list.forEach((poll:any) => {
      poll.state = this.translate.instant('concept-list.poll-pending');
      poll.stateId = 1;
      if(poll.saved){
        poll.state = this.translate.instant('concept-list.poll-completed');
        poll.stateId = 0;
        that.showResultsReports = true;
        child.conceptInfo.answered++;
      }else{
        child.conceptInfo.pending++;
      }
    });
    that.statePoll = true;
  }

  FilterDates(type:any, list:any, child:any){
    let that: any = child.conceptList
    that[type+'Filter'] = true;
    let dates : any ={
      from: that[type+'FromDate'],
      to: that[type+'ToDate']
    }
    return this.filterColumnService.filterByRangeDates(list, type, dates);
  }

  GetFiltratedColumns(filterList:any, child:any){
    let that: any = child.conceptList;
    that.filters.forEach((filter:any) => {
      if(filter === 'managers'){
        filterList = this.filterColumnService.filterBycolumnAllChildren(filterList, that[filter+'ListFilter'], 'fullName', filter);
      }else{
        filterList = this.filterColumnService.filterBycolumn(filterList, that[filter+'ListFilter'], filter);
      }
    });
    that.conceptListFilter = filterList;
    if(that.filterSelectAll){
      this.SelectMultipleConcept('all', null, child);
      that.filterSelectAll = false;
    }
  }

  LaunchActionOption(option:any, item:any, child:any){
    switch(option){
      case 'open':
        if (!child.anySelect) {
          this.OpenEvaluatedConcept(item, child);
        }
        break;
      case 'edit-online':
        if (child.toShow !== 'archived' && !child.anySelect) {
          this.OpenEvaluatedConcept(item, child);
        }
        break;
      case 'edit-local':
        this.registerEvent('open document', child, 'Office local');
        this.editLocal(item);
        break;
      case 'edit-office-365':
        this.registerEvent('open document', child, 'Office 365');
        this.editDocumentOffice365.recieveAndProcessDocument(item);
        break;
      case 'download':
      case 'share':
      case 'publish':
      case 'signature':
      case 'send-mail-certificate':
      case 'send-sms-certificate':
      case 'certify-document':
      case 'request-tracking':
        child.evaluateConcept.emit({evaluateConcept:item, type: option});
        break;
      case 'delete':
        if(!item.reportObjectId){
          let resgisterItem : any ={
            event: 'delete instance',
            conceptName: sessionStorage.getItem('breadcrumbConcept') + item.title
          }
          this.registerService.register(resgisterItem);
        }
        this.DeleteEvaluatedConcept(item, child);
        break;
      case 'openNewTab':
        this.OpenInNewTab(item, child);
        break;
      case 'openAssociated':
        this.OpenAssociatedEvaluation(item, child);
        break;
      case 'assignManager':
        this.AssignManager(item, child);
        break;
      case 'changeToAnonymatum':
        this.anonymizedProcessService.checkAnonymatumProcess(item, child.conceptList.typeComponent)
          .then(() => {
            this.anonymizedProcess(item, child);
          })
          .catch((error:any) => {});
        break;
      case 'openModalConfidential':
        this.OpenModalConfidential(item, child);
        break;
      case 'renameConcept':
        this.RenameConcept(item);
        break;
      case 'archiveConcept0':
        this.ArchiveConcept(item, '0', child);
        break;
      case 'archiveConcept1':
        this.ArchiveConcept(item, '1', child);
        break;
      case 'changeState':
        this.ChangeState(item, child);
        break;
      case 'check-genial':
        if(this.genialDocumentsService.isFileSizeExceeded(item.fileSize, 30)){
        this.modalService.errorModal({ text: this.translate.instant('documentation-list.limited-size-error') });
        }else{
          this.genialDocumentsService.sendToGenial(item, 'report');
        }
      break;
      case 'duplicate':
        this.modalService.renameModal({
        title: this.translate.instant('rename-modal.name-concept-new'),
        type: 'concept',
        labelField: this.translate.instant('rename-modal.name-instance'),
        previousTitle: item.title,
        conceptId: item.conceptId,
        conceptObjectId: item.conceptObjectId,
        list: child.conceptList,
        rename: false
      }).subscribe((result:any) => {
          if(result.result === 'ok'){
            this.duplicateConcept(item, result.name, child);
          }
        })
        break;
      case 'editView':
        if (item.extension.toLowerCase() === 'pdf' && child.toShow !== 'archived' && !child.anySelect) {
          this.OpenEvaluatedConcept(item, child);
        }
        break;
      case 'signature-certification':
      default:
        break;
    }
  }

  duplicateConcept(item:any, name:string, child:any){
    this.loader.openLoader('concept-list-duplicate');
    this.apiService.add(`conceptobjects/${item.conceptObjectId}/duplicate`, {title: name})
    .then((data:any)=>{
      this.loader.closeLoader('concept-list-duplicate');
      let newItem = cloneDeep(item);
      newItem.title = name;
      newItem.conceptObjectId = data.conceptObjectId;
      child.conceptList.conceptList.push(newItem);
      this.FilterComponentList(child);
      this.modalService.successModal({ text: this.translate.instant('concept-list.duplicate-instance-success') });
    }, (errorData:any)=>{
      this.loader.closeError();
      this.modalService.errorModal({ text: errorData.error.message });
      
    })
  }

  OpenEvaluatedConcept(item:any, child:any){
    this.SaveFilter(child);
    let loaderName : any =item.reportId?'report-open-concept': 'folder-open-concept';

    if(!(child.conceptInfo.reportId && child.conceptInfo.type === 0)){
      this.loader.openLoader(loaderName);
    }
    if(item.reportObjectId){
      let resgisterItem : any ={
        event: 'open report',
        reportType: this.convertNumbToName.reportNumbToName(String(item.reportId)),
        source: 'other'
      }
      this.registerService.register(resgisterItem)
    }
    child.evaluateConcept.emit({evaluateConcept:item, type: 'open'});
  }

  editLocal(document:any) {
    let protocol:any = null;
    switch (document.extension) {
      case 'DOC':
      case 'DOCX':
        protocol = 'ms-word';
        break;
      case 'XLS':
      case 'XLSX':
        protocol = 'ms-excel';
        break;
      case 'PPT':
      case 'PPTX':
        protocol = 'ms-powerpoint';
        break;
    }
    if (protocol) {
      let spSite = document.sharepointSiteUrl || document.DepotUri
      let appUri = protocol + ':ofe|u|' + spSite + document.documentLibraryName + '/' + document.editPath;
      window.open(appUri);
      this.apiService.add('documentobjects/logedit/'+document.documentObjectId).then(function(data){}, function(errorData){})
    } else {
      console.log("Local edit: Unknow extension: " + document.extension);
    }
  }

  SaveFilter(child:any){
    let that: any = child.conceptList;
    let current:any = {
      conceptId: child.conceptInfo.conceptId,
      folderId: parseInt(child.folderId),
      configPagination: {
        currentPage: that.configPagination.currentPage,
        firstElement: that.configPagination.firstElement
      },
      selectedConcepts: (that.countConceptSelect ?? []).map((concept: any) => concept.conceptObjectId),
      selectAll: that.selectAll,
      listFilters: {},
      listFilterNames: [],
      textFilters : {},
      hasFilters: 0
    }
    // List filters
    current.listFilterNames = that.filters;

    that.filters.forEach((filter:any) => {
      if(that[filter + 'ListFilter'].length) {
        current.listFilters[filter + 'List'] = that[filter + 'List'];
        current.listFilters[filter + 'ListFilter'] = that[filter + 'ListFilter'];
        current.hasFilters++;
      }
    });
    // Search filters
    that.textFilters.forEach((text:any) => {
      current.textfilter = text;
      current.textFilters[text + 'SearchFilter'] = that[text + 'SearchFilter'];
      if (that[text + 'SearchFilter'] !== '') {
        current.hasFilters++;
      }
    });
    // Creation date filter <<not checked>>
    if (that.creationDateFilter){
      current.hasFilters++;
    }
    // Modification date filter <<not checked>>
    if (that.modificationDateFilter){
      current.hasFilters++;
    }
    this.currentPage.set(current, 'concept');
    if ((child.conceptInfo.namedKey === 'Consulta' || child.conceptInfo.namedKey === 'Usuario')) {
      this.broadcastService.broadcast('cleanFiltersProp', {
        hasFilters: current.hasFilters,
        id: child.conceptInfo.conceptId ? 'con-' + child.conceptInfo.conceptId : 'rep-' + child.conceptInfo.reportId
      })
    }
  }

  OpenInNewTab(item:any, child:any) {
    let url : any = '/evaluation/' +  child.evaluationId + '/reports/' +  item.reportId + '/report-related/' + item.reportObjectId;
    if(item.conceptObjectId){
      url = '/evaluation/' +  child.evaluationId + '/folder/' +  child.folderId + '/concept/' +  child.conceptInfo.conceptId + '/concept-evaluated/' +  item.conceptObjectId;
    }
    url = this.findReportArchived(url, item, child)
    window.open(url, '_blank');
  }

  findReportArchived(url:string, item:any, child:any){
    if(item.conceptObjectId){
      return url
    }
    for(let i: number = 0; i < child.conceptInfo.archived.length; i++){
      let archivedItem = child.conceptInfo.archived[i]
      if(archivedItem.reportObjectId === item.reportObjectId){
        return url +='/archived'
      }
    }
    return url;
  }

  OpenAssociatedEvaluation(concept:any, child:any){
    this.apiService.get('conceptobjects/formsourcepath', concept.conceptObjectId)
      .then((data:any)=>{
        window.open(data, '_blank');
      },(errorData:any)=>{})
  }

  OpenModalConfidential(instance:any, child:any){
    this.modalService.manageConfidentialModal(instance).subscribe((result:any)=>{
      if(result.result ==='ok'){
        this.loader.openLoader('concept-list-confidential-instance');
        this.ConfidentDocument(instance, result, child);
      }
    })
  }

  ConfidentDocument(instance:any, resultModal:any, child:any) {
    let that: any = child.conceptList
    let list:any = resultModal.share;
    let confidential:any = resultModal.confidential.toString();
    let confidentialOfUserConnected:any = resultModal.confidentialOfUserConnected;
    this.apiService.patch('conceptobjects/setconfidential/' +instance.conceptObjectId, confidential, list)
      .then((data:any)=>{
        instance.confidential = !!resultModal.confidential;
        let text:any = instance.confidential? this.translate.instant('manage-confidential-modal.confident-ok') : this.translate.instant('manage-confidential-modal.confident-uncheck');
        if(!instance.confidential){
          instance.confidentialList = [];
        }
        if(instance.confidential && !confidentialOfUserConnected){
          that.conceptList = this.commonUtilsService.deleteElement(instance, that.conceptList, 'conceptObjectId');
          this.FilterComponentList(child);
          child.launchAction.emit({type: 'getEvaluatedConcepts'});
        }
        this.loader.closeLoader(['concept-list-confidential-instance']);
        this.modalService.successModal({ text: text });
      },(errorData:any)=>{
        this.modalService.errorModal({ text: this.translate.instant('manage-confidential-modal.error-confident') });
        this.loader.closeError();
      })
  }

  DeleteEvaluatedConcept(item:any, child:any){
    let text: any = item.reportObjectId?this.translate.instant('concept-list.delete-report-question'):this.translate.instant('concept-list.delete-instance-question');
    this.modalService.infoModal({ text: text, typeButtons: 'cancelRemove' })
      .subscribe((result:any)=>{
        if(result.result === 'ok'){
          this.loader.openLoader('concept-list-concept-list');
          item.reportObjectId? this.DeleteReport(item, child) : this.DeleteEvalConcepts(item, child);
        }
      })
  }

  DeleteReport(report:any, child:any){
    let resgisterItem : any ={
      event: 'delete report',
      reportType: this.convertNumbToName.reportNumbToName(String(report.reportId)),
      source: 'other'
    }
    this.registerService.register(resgisterItem);
    this.apiService.delete('reportobjects', report.reportObjectId)
      .then((data:any) => {
        child.conceptInfo.reportObjects = this.commonUtilsService.deleteElement( report, child.conceptInfo.reportObjects, 'reportObjectId');
        // vm.conceptList = vm.conceptInfo.reportObjects;
        this.ConfigureReportList(child);
        this.FilterComponentList(child);
        this.loader.closeLoader(['concept-list-concept-list']);
        this.modalService.successModal({ text: this.translate.instant('concept-list.report-deleted') });
      }, (errorData:any) => {
        this.loader.closeError();
        let text: string = errorData.status === 403? 'concept-list.delete-error-permissions':'concept-list.delete-error-concept'
        this.modalService.errorModal({ text: this.translate.instant(text) });
      });
  }

  DeleteEvalConcepts(concept:any, child:any){
    this.apiService.delete('conceptobjects', concept.conceptObjectId)
    .then((data:any)=>{
      child.conceptList.conceptList = this.commonUtilsService.deleteElement( concept, child.conceptList.conceptList, 'conceptObjectId')
      child.conceptList.emptyList = child.conceptList.conceptList.length?false:true;
      this.loader.closeLoader(['concept-list-concept-list']);
      if(!child.conceptList.conceptList.length && child.toShow==='archived'){
        child.launchAction.emit({toShow:'evaluated', type: 'showElements'});
      }else{
        this.FilterComponentList(child);
        child.launchAction.emit({type: 'getEvaluatedConcepts'});
      }
      if(concept.isArchived){
        child.conceptInfo.archivedAmount--;
      }
      if(child.skin !== 'icam-red'){
        this.broadcastService.broadcast('getDraftEvaluations');
      }
      this.modalService.successModal({ text: this.translate.instant('concept-list.delete-concept-ok') });
      this.GetFilters(child.conceptList.conceptList, child)
    }, (errorData:any)=>{
      this.loader.closeError();
      let text:string = errorData.status === 403? 'concept-list.delete-error-permissions' : 'concept-list.delete-error-concept';
      this.modalService.errorModal({ text: this.translate.instant(text) });
    });
  }

  OrderDate(type:any, child:any){
    if(child.conceptList.filterOrder === type){
      child.conceptList.order = !child.conceptList.order;
    }else{
      child.conceptList.filterOrder = type;
      child.conceptList.order = !(type !== 'title');
    }
  }

  ArchiveConcept(concept:any, archived:any, child:any){
    let text : string = archived === '0' ? this.translate.instant('concept-list.restore-instance-question') : this.translate.instant('concept-list.archive-instance-question');
    let typeButtons: string = archived === '0' ? 'restore': 'cancelArchive';
    this.modalService.infoModal({ text: text, typeButtons: typeButtons }).subscribe((result:any)=>{
      if(result.result !== 'cancel'){
        this.loader.openLoader('concept-list-archive-concept');
        this.ArchiveConceptService(concept, archived, child)
      }
    })
  }

  ArchiveConceptService(concept:any, archived:any, child:any){
    this.apiService.patch('conceptobjects/archived/'+concept.conceptObjectId, archived)
      .then((data:any)=>{
        concept.isArchived = !concept.isArchived;
        child.conceptList.conceptList = this.commonUtilsService.deleteElement( concept, child.conceptList.conceptList, 'conceptObjectId')
        child.toShow!=='archived'? child.conceptInfo.archived.push(concept) : child.conceptInfo.list.push(concept);
        this.loader.closeLoader(['concept-list-archive-concept']);
        let text:any = archived === '0'? 'concept-list.restore-concept-success' : 'concept-list.archive-concept-success';
        this.modalService.successModal({ text: this.translate.instant(text) });
        child.launchAction.emit({type: 'updateConcept'});
      }, (errorData:any)=>{
        this.loader.closeError();
        this.modalService.errorModal({ text: this.translate.instant('concept-list.archive-concept-error') });
      });

  }

  ChangeCalendar(dates:any, type:any, child:any){
    let that: any = child.conceptList
    // that[type+'Open'] = false;
    that[type+'Filter'] = dates.type === 'cancel'? that[type+'Filter'] : dates.type === 'apply';
    if(dates.type !== 'cancel'){
      that[type+'FromDate'] = dates.from;
      that[type+'ToDate'] = dates.to;
      that[type+'OptionCalendar'] = 'select';
      let filterList:any;
      if(dates.type === 'apply' && ((type === 'creationDate' && that.modificationDateFilter) || (type === 'modificationDate' && that.creationDateFilter))){
        filterList = this.filterColumnService.filterByRangeDates(that.conceptListFilter, type, dates);
      }else if(dates.type === 'restore' && ((type === 'creationDate' && that.modificationDateFilter) || (type === 'modificationDate' && that.creationDateFilter))){
        let dateModification : any = {
          from: type === 'modificationDate' ? that.creationDateFromDate : that.modificationDateFromDate,
          to: type === 'modificationDate' ? that.creationDateToDate : that.modificationDateToDate
        }
        let typeFilter : any = type === 'creationDate'? 'modificationDate' : 'creationDate';
        filterList = this.filterColumnService.filterByRangeDates(that.conceptList, typeFilter, dateModification);
      }else{
        filterList = this.filterColumnService.filterByRangeDates(that.conceptList, type, dates);
      }
      this.GetFiltratedColumns(filterList, child);
    }
  }

  AssignManager(concept:any, child:any){
    if(!child.conceptList.countConceptSelect.length){
      child.conceptList.countConceptSelect.push(concept)
    }
    this.modalService.assignManager(child.conceptList.countConceptSelect.length).subscribe((result:any)=>{
      if(result.result === 'ok'){
        this.loader.openLoader('concept-list-assign-manager');
        this.SaveAssignManager(result.managers, child);
      }
    })
  }

  SaveAssignManager(managers:any, child:any){
    let that: any = child.conceptList
    this.apiService.patch('conceptobjects/concept', child.conceptInfo.conceptId+'/set-managers', this.ExtractManagersObjectsId(managers, child))
      .then((data:any)=>{
        that.conceptListFilter = [];
        that.countConceptSelect.forEach((countConceptSelect:any) => {
          for(let i: number = 0; i < that.conceptList.length; i++){
            let conceptList: any = that.conceptList[i]
            if(countConceptSelect.conceptObjectId === conceptList.conceptObjectId){
              conceptList.managers = managers;
              conceptList.selectedConcept = false;
              that.conceptList.splice(i, 1, conceptList)
              break;
            }
          }
        });

        that.countConceptSelect = [];
        that.anySelect = false;
        this.loader.closeLoader(['concept-list-assign-manager']);
        this.modalService.successModal({ text: this.translate.instant('concept-list.assign-manager-success') });
        that.selectAll = false;
        this.FilterComponentList(child);
      }, (errorData:any)=>{
        this.loader.closeError();
        this.modalService.errorModal({ text: this.translate.instant('concept-list.unexpected-error') });
      })
  }

  ExtractManagersObjectsId(managers: any, child:any){
    let objectBody: any = {
      conceptObjectIds: [],
      managers: []
    }
    child.conceptList.countConceptSelect.forEach((conceptSelect:any) => {
      objectBody.conceptObjectIds.push(conceptSelect.conceptObjectId);
    })
    managers.forEach((manager:any) => {
      if(manager.type==='U'){
        objectBody.managers.push({userId: manager.id});
      }else if(manager.type==='R'){
        objectBody.managers.push({productRoleId: manager.id});
      }
    })
    return objectBody;
  }

  ChangeState(evaluateConcept:any, child:any){
    this.modalService.changeState(evaluateConcept).subscribe((result:any)=>{
      if(result.result === 'ok'){
        let state : any = result.state
        child.conceptList.direction = state.option
        if(evaluateConcept.managers && !this.checkManagers(evaluateConcept.managers)){
          this.modalService.warningModal({ text: this.translate.instant('states-process.not-responsible'), typeButtons: 'cancelContinue' })
            .subscribe((result: any)=>{
              if(result.result !== 'cancel'){
                this.ChangeProcessAdvice(state.itemSelected, state.option, evaluateConcept, child);
              }
            })
        }else{
          this.ChangeProcessAdvice(state.itemSelected, state.option, evaluateConcept, child);
        }
      }
    })
  }

  checkManagers(managers:any){
    for(let i:number = 0; i < managers.length; i++){
      if(managers[i].id === this.context.user.userId){
        return true;
      }
    }
    return false;
  }

  ChangeProcessAdvice(itemSelected:any, option:any, evaluateConcept:any, child:any){
    let typeButtons: string = option === 'next'?'advance':'goBack';
    let text: string = itemSelected.archiveConceptObject?this.translate.instant('states-process.change-state-advice-archived'):this.translate.instant('states-process.change-state-advice');
    this.modalService.infoModal({ text: text, typeButtons: typeButtons })
      .subscribe((result: any)=>{
        if(result.result ==='ok'){
          this.ChangeStateProcess(itemSelected, option, evaluateConcept, child)
        }
      })
  }

  ChangeStateProcess(itemSelected:any, option:any, evaluateConcept:any, child:any){
    let state:any = {
      transitionId: itemSelected.transitionId
    }
    if(itemSelected && itemSelected.hasAlertCustom && option !== "previous"){
      this.modalService.personzalizedNotificationModal(evaluateConcept, itemSelected).subscribe((result:any)=>{
        if(result.result ==='ok'){
          this.loader.openLoader('add-undo-transition');
          state.customBody = result.customEmail.customBody;
          state.customSubject = result.customEmail.customSubject;
          this.ConfigureTransition(state, true, option, evaluateConcept, itemSelected.stateName, child);
        }
      })
    }else{
      this.loader.openLoader('add-undo-transition');
      this.ConfigureTransition(state, false, option, evaluateConcept, itemSelected.stateName, child);
    }
  }

  ConfigureTransition(state:any, personzalizedNotification:any, direction:any, evaluateConcept:any, stepName:any, child:any){
    let event : any = direction === 'next'? 'advance process' : 'back process';
    let callApi : any = direction === 'next'
      ? this.apiService.add('processesdata/' +evaluateConcept.conceptObjectId, state)
      : this.apiService.delete('processesdata/' + evaluateConcept.conceptObjectId + '/last/' + state.transitionId, state);
    let registerItem : any = {
      event: event,
      stepName: stepName,
      conceptName: sessionStorage.getItem('breadcrumbConcept') + evaluateConcept.title,
      processName: evaluateConcept.processStates.next.name
    }
    this.registerService.register(registerItem);
    this.AddOrUndoTransition(callApi, evaluateConcept, personzalizedNotification,child);
  }

  AddOrUndoTransition(apiCall:any, evaluateConcept:any, personzalizedNotification:any, child:any){
    let current:any = null
    apiCall.then((data:any)=>{
      if (data && data.current) {
        current = data.current
        this.rechargeFilterStep(current, evaluateConcept, child);
      }
      this.loader.closeLoader(['add-undo-transition']);
      let text : string = personzalizedNotification? this.translate.instant('states-process.personalized-notification-ok') : this.translate.instant('states-process.not-personalized-ok');
      this.modalService.successModal({ text: text })
        .subscribe((result:any)=>{
          if(current.anonymizeConceptObject && child.conceptList.direction === 'next' && !evaluateConcept.anonymized){
            this.infoAnonymizedConcept(evaluateConcept, child)
          }
        });
    }, (errorData:any)=>{});
  }

   infoAnonymizedConcept(item:any, child:any){
    this.modalService.infoModal({
      text: this.translate.instant('states-process.anonymized-process-info'),
      typeButtons: 'anonymize'
    }).subscribe((result:any)=>{
      if(result.result === 'ok'){
        this.anonymizedProcessService.checkAnonymatumProcess(item, 'process')
          .then(() => {
            this.anonymizedProcess(item, child);
          })
          .catch((error:any) => {});
      }
    })
  }

  rechargeFilterStep(processCurrent: any, evaluateConcept: any, child: any){
    // change concept step
    for (let i = 0; i < child.conceptList.conceptList?.length; i++) {
      if (child.conceptList.conceptList[i].conceptObjectId === evaluateConcept.conceptObjectId) {
        evaluateConcept.step = processCurrent.name;
        break;
      }
    }
    // get steps with concepts
    const stepsWithConcepts = new Set<string>();
    for (const concept of child.conceptList.conceptList) {
      if (!stepsWithConcepts.has(concept.step)) {
        stepsWithConcepts.add(concept.step);
      }
    }
    // add step if it's new
    if (!child.conceptList.stepList.find((step: any) => step.name === processCurrent.name)) {
      child.conceptList.stepList.push({
        name: processCurrent.name,
        nameToShow: processCurrent.name,
        index: child.conceptList.stepList.length,
        selected: false
      });
    }
    // remove steps without concepts
    child.conceptList.stepList = child.conceptList.stepList.filter((step: any) => stepsWithConcepts.has(step.name));
    child.conceptList.stepListFilter = child.conceptList.stepListFilter.filter((step: any) => stepsWithConcepts.has(step.name));
    child.conceptList.stepFilter.hasFilter = !!(child.conceptList.stepListFilter?.length);
    this.FilterComponentList(child);
  }

  OrderBySearch(e:any, type:any, child: any){
    let newValue: any = e.newValue;
    child.conceptList[type+'SearchFilter'] = newValue;
    this.FilterComponentList(child);
  }

  anonymizedProcess(concept:any, child:any){
    let resgisterItem : any ={
      event: 'Anonymize data',
      source: 'Instance'
    }
    this.registerService.register(resgisterItem);
    const type = child.conceptList.typeComponent === 'globalReport'?'anonymatum-report' : 'anonymized-process'
    this.anonymizedProcessService.anonymatumDocument(type, concept)
      .then((result:any) => {
        this.findAndReplaceAnonymized(result, child)
        this.FilterComponentList(child);
        this.modalService.successModal({ text: this.translate.instant('concept-list.anonymatum-concept-ok') });
      }).catch(error => {
        this.modalService.errorModal({ text: this.translate.instant('concept-list.anonymatum-concept-error') });
      });
  }

  findAndReplaceAnonymized(result:any, child: any){
    for(let i = 0; i < child.conceptList.conceptList.length; i++){
      let conceptItem: any = child.conceptList.conceptList[i]
      if(child.conceptList.typeComponent === 'globalReport' && result.item.reportDocumentId === conceptItem.reportDocumentId){
        child.conceptList.conceptList.splice(i, 1, result.item);
        break;
      }else{
        if(conceptItem.conceptObjectId === result.item.conceptObjectId){
          let conceptToModify:any = cloneDeep(conceptItem)
          conceptToModify.author = result.item.createdBy;
          conceptToModify.title = result.item.title;
          conceptToModify.anonymized = true;
          child.conceptList.conceptList.splice(i, 1, conceptToModify);
          break;
        }
      }
    }
  }

  RenameConcept(concept: any){
    let configuration : any = {
      title: this.translate.instant('rename-modal.name-instance-rename'),
      type: 'concept',
      previousTitle: concept.title,
      conceptId: concept.conceptId,
      conceptObjectId: concept.conceptObjectId,
      // list: [],
      rename: true
    }
    this.modalService.renameModal(configuration)
      .subscribe((result:any)=>{
        if(result.result==='ok'){
          this.loader.openLoader('concept-tab-rename-modal');
          this.changeConceptName(result.name, concept);
        }
      })
  }

  changeConceptName(name: any, concept: any){
    this.apiService.patch('conceptobjects/' + concept.conceptObjectId, 0,{ title: name })
      .then((data:any)=>{
        concept.title = name;
        this.loader.closeLoader(['concept-tab-rename-modal']);
        this.modalService.successModal({ text: this.translate.instant('concept-tab.change-name-ok') });
      }, (errorData:any)=>{
        this.loader.closeError();
        let text : string = errorData.description==='UqConstraint'?this.translate.instant('concept-tab.error-same-name'):this.translate.instant('concept-tab.error-name');
        this.modalService.errorModal({ text: text });
      });
  }

  filterOrder(e: any, type:any='', child: any){
    switch(e.action){
      case 'filter':
        this.SelectTypeOperation(e.newValue, type, child);
        break;
      case 'search':
        this.OrderBySearch(e, type, child);
        break;
      case 'order':
        this.OrderDate(type, child);
        break;
      case 'calendar':
        this.ChangeCalendar(e.newValue, type, child);
        break;
    }
  }

  changeCurrentPage(e: any, child: any){
    child.conceptList.configPagination.currentPage = e.currentPage;
    child.conceptList.configPagination.firstElement = e.firstElement;
    this.SaveFilter(child);
  }

  openActionInstance(instance: any, child: any, type: string = 'default'){
    let optionAction = {};
    switch(type){
      case 'digitalization':
      case 'publication':
      case 'collegiate':
        optionAction = {
          toShow: child.toShow,
          conceptInfo: child.conceptInfo,
          userPermissions: child.userPermissions
        }
        instance.expandedMenu = this.expandedMenuService.conceptList(this.expandedMenu['conceptList'].menu, optionAction);
        break;
      case 'query':
        optionAction = {
          toShow: child.toShow,
          conceptList: child.conceptList,
          conceptInfo: child.conceptInfo,
          userPermissions: child.userPermissions
        }
        instance.expandedMenu = this.expandedMenuService.conceptListQuery(this.expandedMenu['conceptListQuery'].menu, optionAction, instance);
        break;
      case 'poll':
        optionAction = {
          conceptInfo: child.conceptInfo,
          userPermissions: child.userPermissions
        }
        instance.expandedMenu = this.expandedMenuService.conceptListPoll(this.expandedMenu['conceptListPoll'].menu, optionAction, instance);
        break;
      case 'globalReport':
        optionAction = {
          toShow: child.toShow,
          conceptInfo: child.conceptInfo,
          sibila: this.context.areas.sibila,
          canSignDocuments: this.context.user.canSignDocuments,
          menuDocumentSignature: this.expandedMenu['menuDocumentSignature'].menu,
          menuDocumenteditView: this.expandedMenu['menuDocumentOpenReport'].menu
        }
        instance.expandedMenu = this.expandedMenuService.conceptListGlobalReport(this.expandedMenu['conceptListGlobalReport'].menu, instance, optionAction);
        break;
      default:
        optionAction = {
          toShow: child.toShow,
          conceptList: child.conceptList,
          conceptInfo: child.conceptInfo,
          evaluation: child.evaluation
        };
        instance.expandedMenu = this.expandedMenuService.conceptInstancesActions(this.expandedMenu['conceptInstancesActions'].menu, instance, optionAction);
        break;
    }
    instance.openMenuAction = true;
  }

  registerEvent(type:string, child:any, source: any = null){
    let resgisterItem:any ={
      event:type,
      conceptName: child.conceptInfo.breadCrumb +' > '+child.conceptInfo.title,
      source: source && source !== null? source : 'reports'
    }
    this.registerService.register(resgisterItem)
  }


  ngOnDestroy(){
    this.commonUtilsService.OnDestroy(this.subscribers);
  }
}
